"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _reactRouterDom = require("react-router-dom");

var _reactJss = require("react-jss");

var LockedstylesWithProps = function LockedstylesWithProps(props) {
  return {};
};

var Lockedstyles = {};
var styles = (0, _reactJss.createUseStyles)(function (theme) {
  return {
    NavTopBarSubLink: theme.NavTopBarSubLink,
    NavTopBarSubLink_Content: theme.NavTopBarSubLink_Content
  };
});
/**
 * Create a SubNavlink element for the NavTopBar
 */

var NavTopBarSubLink = /*#__PURE__*/_react["default"].forwardRef(function NavTopBarSubLink(props, ref) {
  var Slug = props.Slug,
      ClassOverrideNavTopBarSubLink = props.ClassOverrideNavTopBarSubLink,
      ClassExtendNavTopBarSubLink = props.ClassExtendNavTopBarSubLink,
      ClassOverrideNavTopBarSubLink_Content = props.ClassOverrideNavTopBarSubLink_Content,
      ClassExtendNavTopBarSubLink_Content = props.ClassExtendNavTopBarSubLink_Content,
      className = props.className,
      children = props.children,
      other = (0, _objectWithoutProperties2["default"])(props, ["Slug", "ClassOverrideNavTopBarSubLink", "ClassExtendNavTopBarSubLink", "ClassOverrideNavTopBarSubLink_Content", "ClassExtendNavTopBarSubLink_Content", "className", "children"]);
  var theme = (0, _reactJss.useTheme)();
  var classes = styles((0, _extends2["default"])({}, props, {
    theme: theme
  }));

  var FinalComponent = function FinalComponent() {
    if (Slug) {
      return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.NavLink, (0, _extends2["default"])({
        to: "".concat(Slug),
        ref: ref
      }, other, {
        className: ClassOverrideNavTopBarSubLink ? ClassOverrideNavTopBarSubLink : (0, _clsx["default"])(classes.NavTopBarSubLink, ClassExtendNavTopBarSubLink)
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: ClassOverrideNavTopBarSubLink_Content ? ClassOverrideNavTopBarSubLink_Content : (0, _clsx["default"])(classes.NavTopBarSubLink_Content, classes.ClassExtendNavTopBarSubLink_Content)
      }, children));
    } else {
      return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
        ref: ref
      }, other, {
        className: ClassOverrideNavTopBarSubLink ? ClassOverrideNavTopBarSubLink : (0, _clsx["default"])(classes.NavTopBarSubLink, ClassExtendNavTopBarSubLink)
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: ClassOverrideNavTopBarSubLink_Content ? ClassOverrideNavTopBarSubLink_Content : (0, _clsx["default"])(classes.NavTopBarSubLink_Content, classes.ClassExtendNavTopBarSubLink_Content)
      }, children));
    }
  };

  return /*#__PURE__*/_react["default"].createElement(FinalComponent, null);
});

NavTopBarSubLink.defaultProps = {
  Slug: null,
  ClassOverrideNavTopBarSubLink: null,
  ClassExtendNavTopBarSubLink: null,
  ClassOverrideNavTopBarSubLink_Content: null,
  ClassExtendNavTopBarSubLink_Content: null
};
process.env.NODE_ENV !== "production" ? NavTopBarSubLink.propTypes = {
  /**
   * The relative link to the page to display
  * If no Slug is passed, then it will just be a button type component
   */
  Slug: _propTypes["default"].string,

  /**
   * Override the class
   */
  ClassOverrideNavTopBarSubLink: _propTypes["default"].string,

  /**
   * Extend the class
   */
  ClassExtendNavTopBarSubLink: _propTypes["default"].string,

  /**
   * Override the class
   */
  ClassOverrideNavTopBarSubLink_Content: _propTypes["default"].string,

  /**
   * Extend the class
   */
  ClassExtendNavTopBarSubLink_Content: _propTypes["default"].string
} : void 0;
var _default = NavTopBarSubLink;
exports["default"] = _default;